import { ISnackbarValidation, Snackbar } from '@/types/_'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'SnackbarStore' })
export default class SnackbarStore extends VuexModule {
  private snackbarDefault: Snackbar = {
    disabled: false,
    disabledBtn: false,
    message: '',
    show: false,
    timeout: 6000,
  }

  public snackbar: Snackbar = { ...this.snackbarDefault }

  @Action
  snackbarValid(snackbarValidation: ISnackbarValidation) {
    if (!snackbarValidation.success) {
      const snack: Snackbar = {
        disabled: false,
        disabledBtn: true,
        message: `Total de ${snackbarValidation.total} erro(s) foi encontrado.`,
        show: true,
        timeout: 8000,
      }
      this.context.commit('setSnackbar', snack)
    }
  }

  @Mutation
  setSnackbar(snackbar: Snackbar) {
    this.snackbar = snackbar
  }

  @Mutation
  clear() {
    this.snackbar = { ...this.snackbarDefault }
  }
}
